import { __rest } from 'tslib';
import React, { useRef, useEffect, useState } from 'react';
import { PeekBox, PeekBadge, PeekContainedIconButton, PeekTypography, PeekDialog, PeekDialogContent, PeekDialogContentText, PeekTextField, PeekDialogActions, PeekButton } from '@piiqtechnologies/ui-components';
import { Edit2 } from '@piiqtechnologies/svg-icons';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import { HotspotType } from '../../../../types/Space.js';
import '../../../../types/Tour.js';
import { HotspotIcon } from './HotspotIcon.js';
import '../../../../services/base/baseDiscoverService.js';
import '../../../../services/base/baseV3Service.js';
import '../../../../services/base/baseInsightsService.js';
import '../../../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../../../utils/ErrorProvider.js';
import '../../../../utils/LoaderProvider.js';
import '../../../../utils/RefetchProvider.js';
import '../../../../utils/NotificationProvider.js';
import '../../../../utils/ContactProvider.js';
import '../../../../utils/PolicyProvider.js';
import '../../../../utils/AnalyticsProvider.js';
import '../../../../utils/analyticsPlugin.js';
import '../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../utils/cookieUtils.js';
import '../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../services/base/internalApiBaseService.js';
import '../../../../services/base/casaBaseService.js';
import '../../../../services/scanRequestsService.js';
import '../../../../services/db/insightsReportsDB.js';
import '../../../../services/aiDiscoverability.js';
import 'dot-object';
import '../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useUpdateSpaceNode } from '../../../../apis/space/useUpdateSpaceNode.js';
import '../../../../apis/upload/useSignedURL.js';
import produce from 'immer';

const EditButton = () => (React.createElement(PeekTypography, { color: "text.secondary", variant: "h4" },
    React.createElement(Edit2, null)));
const BaseHotspotEditView = ({ helpers, name: hotspotName, type, onEdit, onDelete, editInProgress, editError, updatedSpace, sceneId, }) => {
    const [editHotspotModal, setEditHotspotModal] = useState(false);
    const [deleteHotspotModal, setDeleteHotspotModal] = useState(false);
    const [name, setName] = useState(hotspotName);
    const onChangeName = (event) => {
        setName(event.target.value);
    };
    const buttonBackground = (type === HotspotType.Space && "common.purple") || "secondary.main";
    const buttonSxProps = {
        backgroundColor: buttonBackground,
        ":hover": { backgroundColor: buttonBackground },
    };
    const { setError, setLoader, setViewerContext, setRefetch, getContainer } = helpers;
    const pannellumRef = getContainer && getContainer();
    useEffect(() => {
        setLoader && setLoader(editInProgress);
    }, [editInProgress]);
    useEffect(() => {
        if (editError) {
            setError && setError(editError === null || editError === void 0 ? void 0 : editError.message);
        }
    }, [editError]);
    useEffect(() => {
        if (updatedSpace) {
            setViewerContext({ details: updatedSpace });
            setRefetch && setRefetch({ sceneId });
        }
    }, [updatedSpace]);
    const toggleEditHotspotModal = () => {
        setEditHotspotModal((editHotspotModal) => !editHotspotModal);
    };
    const toggleDeleteHotspotModal = () => {
        toggleEditHotspotModal();
        setDeleteHotspotModal((deleteHotspotModal) => !deleteHotspotModal);
    };
    const onUpdate = () => {
        onEdit(name);
        toggleEditHotspotModal();
    };
    const onDeleteHotspot = () => {
        onDelete();
        toggleDeleteHotspotModal();
        toggleEditHotspotModal();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekBadge, { onClick: toggleEditHotspotModal, overlap: "circular", badgeContent: React.createElement(EditButton, null), color: "warning", sx: { "& .MuiBadge-badge": { top: 4, right: 4, px: 0.2, py: 1 } } },
            React.createElement(PeekContainedIconButton, { sx: buttonSxProps, "aria-label": "hotspot" },
                React.createElement(PeekTypography, { color: "text.secondary", fontSize: 22 },
                    React.createElement(HotspotIcon, { type: type })))),
        React.createElement(PeekDialog, { sx: { position: "absolute", zIndex: 9999 }, container: pannellumRef === null || pannellumRef === void 0 ? void 0 : pannellumRef.parentElement, maxWidth: "xs", open: editHotspotModal, onClose: toggleEditHotspotModal },
            React.createElement(PeekDialogContent, null,
                React.createElement(PeekDialogContentText, { color: "text.primary" }, (type === HotspotType.Info && "Edit InfoSpot") || "Edit Link's Label"),
                React.createElement(PeekTextField, { variant: "standard", fullWidth: true, multiline: true, rows: 4, value: name, onChange: onChangeName, InputProps: {
                        disableUnderline: true,
                        "aria-label": "Hotspot Name",
                    } })),
            React.createElement(PeekDialogActions, { sx: { justifyContent: "center" } },
                React.createElement(PeekButton, { onClick: toggleDeleteHotspotModal, color: "error", variant: "outlined" }, "Delete"),
                React.createElement(PeekButton, { onClick: toggleEditHotspotModal, color: "info", variant: "outlined" }, "Cancel"),
                React.createElement(PeekButton, { color: "secondary", onClick: onUpdate, variant: "contained" }, "Save"))),
        React.createElement(PeekDialog, { sx: { position: "absolute", zIndex: 9999 }, container: pannellumRef === null || pannellumRef === void 0 ? void 0 : pannellumRef.parentElement, maxWidth: "xs", open: deleteHotspotModal, onClose: toggleDeleteHotspotModal },
            React.createElement(PeekDialogContent, null,
                React.createElement(PeekDialogContentText, { color: "error" }, "Are you sure you want to delete this hotspot?")),
            React.createElement(PeekDialogActions, { sx: { justifyContent: "center" } },
                React.createElement(PeekButton, { onClick: onDeleteHotspot, sx: {
                        ":hover": {
                            backgroundColor: "error.main",
                        },
                    }, color: "error", variant: "contained" }, "Delete"),
                React.createElement(PeekButton, { onClick: toggleDeleteHotspotModal, color: "info", variant: "outlined" }, "Cancel")))));
};
const InfospotEditView = ({ relatedContext: { node, id }, helpers, sceneId, hotspot, }) => {
    const [updateSpaceNode, updatedSpace, updateSpaceNodeInProgress, updateSpaceNodeError] = useUpdateSpaceNode();
    const updateInfospot = (name) => {
        if (node) {
            const infospotIndex = node.infospots.findIndex((item) => item._id === hotspot._id);
            const updatedSpaceNode = produce(node, (draftState) => {
                draftState.infospots[infospotIndex].text = name;
            });
            updateSpaceNode({
                spaceId: id,
                nodeId: sceneId,
                node: {
                    infospots: updatedSpaceNode.infospots.map((_a) => {
                        var infospotData = __rest(_a, ["_id"]);
                        return infospotData;
                    }),
                },
            });
        }
    };
    const deleteInfospot = () => {
        if (node) {
            updateSpaceNode({
                spaceId: id,
                nodeId: sceneId,
                node: {
                    infospots: node.infospots
                        .filter((item) => item._id !== hotspot._id)
                        .map((_a) => {
                        var infospotData = __rest(_a, ["_id"]);
                        return infospotData;
                    }),
                },
            });
        }
    };
    return (React.createElement(BaseHotspotEditView, { sceneId: sceneId, helpers: helpers, name: hotspot.text, type: HotspotType.Info, onEdit: updateInfospot, editError: updateSpaceNodeError, editInProgress: updateSpaceNodeInProgress, updatedSpace: updatedSpace, onDelete: deleteInfospot }));
};
const NodeLinkEditView = ({ relatedContext: { id, node }, helpers, sceneId, hotspot, }) => {
    const [updateSpaceNode, updatedSpace, updateSpaceNodeInProgress, updateSpaceNodeError] = useUpdateSpaceNode();
    const updateNodeLink = (name) => {
        if (node) {
            const nodeLinkIndex = node.nodeLinks.findIndex((item) => item._id === hotspot._id);
            const updatedSpaceNode = produce(node, (draftState) => {
                draftState.nodeLinks[nodeLinkIndex].label = name;
            });
            updateSpaceNode({
                spaceId: id,
                nodeId: sceneId,
                node: {
                    nodeLinks: updatedSpaceNode.nodeLinks.map((_a) => {
                        var nodeLinkData = __rest(_a, ["_id", "scale", "autoLink", "visibilityJustification"]);
                        return nodeLinkData;
                    }),
                },
            });
        }
    };
    const deleteNodeLink = () => {
        if (node) {
            updateSpaceNode({
                spaceId: id,
                nodeId: sceneId,
                node: {
                    nodeLinks: node.nodeLinks
                        .filter((item) => item._id !== hotspot._id)
                        .map((_a) => {
                        var nodeLinkData = __rest(_a, ["_id", "scale", "autoLink", "visibilityJustification"]);
                        return nodeLinkData;
                    }),
                },
            });
        }
    };
    return (React.createElement(BaseHotspotEditView, { sceneId: sceneId, helpers: helpers, name: hotspot.label, type: hotspot.type, onEdit: updateNodeLink, editError: updateSpaceNodeError, editInProgress: updateSpaceNodeInProgress, updatedSpace: updatedSpace, onDelete: deleteNodeLink }));
};
const HotspotEditView = (props) => {
    const { relatedContext: { isEditing }, infospot, hotspot, } = props;
    const dragRef = useRef(null);
    const dragStartCb = (event) => {
        event.dataTransfer.dropEffect = "move";
        event.dataTransfer.setData("hotspot", JSON.stringify(props));
    };
    useEffect(() => {
        var _a;
        const elem = (_a = dragRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (elem && isEditing) {
            elem.setAttribute("draggable", "true");
            elem.addEventListener("dragstart", dragStartCb);
            return () => {
                elem.removeEventListener("dragstart", dragStartCb);
            };
        }
    }, [isEditing]);
    return (React.createElement(PeekBox, { ref: dragRef }, (infospot && React.createElement(InfospotEditView, Object.assign({}, props, { hotspot: hotspot }))) || (React.createElement(NodeLinkEditView, Object.assign({}, props, { hotspot: hotspot })))));
};

export { BaseHotspotEditView, HotspotEditView as default };
